import { render, staticRenderFns } from "./VeJwJingsaiScoreListOld.vue?vue&type=template&id=4cafc0c8&scoped=true"
import script from "./VeJwJingsaiScoreListOld.vue?vue&type=script&lang=js"
export * from "./VeJwJingsaiScoreListOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cafc0c8",
  null
  
)

export default component.exports